import { SignupProfile } from "../pages/Signup/SignupProfile";
import { createBrowserRouter } from "react-router-dom";
import App from "@app/App";
import { msalInstance } from "@app/helpers";
import FeaturesRoutes from "@app/pages/Features/Features.routes";
import { ErrorsRoutes } from "@app/pages/Errors";
import { Login } from "@app/pages/Login";

const router = createBrowserRouter([
  { path: "/signup/profile", element: <SignupProfile /> },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/",
    element: <App instance={msalInstance} />,
    children: [...FeaturesRoutes, ...ErrorsRoutes],
  },
]);

export default router;
